<script setup lang="ts">
import type { NewsItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<NewsItemProps>(), {})

const app = useNuxtApp()
const storeIndex = useStoreIndex()
</script>

<template>
  <div
    class="c-newsItem"
  >
    <div class="c-newsItem_imageBox">
      <nuxt-link
        class="u-hoverZoom"
        v-bind:to="`/news/${item.article_slug}`"
      >
        <CommonImage
          v-bind:src="storeIndex.getArticleEyeCatchImageURL(item.eye_catch_image_object)"
          error-src="/images/noimage.svg"
          v-bind:alt="item.title"
          height="150"
          object-fit="cover"
          is-hover-effect
        />
      </nuxt-link>
    </div>
    <div class="c-newsItem_info">
      <nuxt-link
        class="c-newsItem_info_title c-clampLines is-clampline2"
        v-bind:to="`/news/${item.article_slug}`"
      >
        {{ item.title }}
      </nuxt-link>
      <div class="c-newsItem_info_date">
        （掲載日時:{{ app.$getPeriodDayLabelNoDD(item.open_date) }}）
      </div>
      <div
        class="c-newsItem_info_link"
      >
        <ArrowLink
          v-bind:to="`/news/${item.article_slug}`"
          label="ニュースを見る"
          bold
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-newsItem {
  display: flex;
  gap: 24px;
  width: 100%;
  margin-top: 40px;
  padding: 20px;
  background-color: var(--color_background_whiteblue);
  color: var(--color_text_base);
  font-family: var(--g_font_family_NotoSansCJKjp);

  @include responsive.mq_down(sp) {
    flex-direction: column;
    gap: 16px;
  }

    &_imageBox {
      flex-shrink: 0;
      width: 200px;

      @include responsive.mq_down(sp) {
        width: 100%;
      }
    }
    &_info {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: space-between;

      @include responsive.mq_down(sp) {
        display: block;
      }

      &_title {
        margin-top: -5px !important;
        color: var(--color_text_base);
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 20px;
        font-weight: bold;
        letter-spacing: -0.2px;

        @include responsive.mq_down(sp) {
          font-size: 18px;
        }
      }

      &_date {
        font-family: var(--color_text_base);
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 14px;
      }

      &_link {
        display: flex;
        justify-content: flex-end;
      }
    }
}
</style>
